/**
 * @Author ytyjm
 * @Create Time 2020/3/23
 * @Description: 请求拦截处理
 */
import axios from 'axios'
import { getToken } from '@/libs/token'

// axios baseURL
axios.defaults.baseURL = process.env.VUE_APP_BASE_API

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,    // 实例 baseURL
  timeout: 6000
})

instance.interceptors.request.use(config => {
  const token = getToken()
  token && (config.headers['X-Access-Token'] = token)

  return config
}, err => {
  return Promise.reject(err)
})

instance.interceptors.response.use(res => {
  /* 错误处理 */
  // ......

  return res
}, err => {
  return Promise.reject(err)
})

export default instance
